import api from './api';

const ENDPOINT = 'clients';

const ClientService = {
    get: (params = null) => api.get(ENDPOINT, { params }),
    getId: (id) => api.get(`${ENDPOINT}/${id}`),
    save: (data) => api.post(`${ENDPOINT}`, data),
    update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
    delete: (id) => api.delete(`${ENDPOINT}/${id}`),
    search: (term) => api.get(`${ENDPOINT}/search`, { params: { term } }),
    importCards: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return api.post(`${ENDPOINT}/import-cards`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
            },
        });
    },
    import: (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return api.post(`${ENDPOINT}/import`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
            },
        });
    },
    toggleMultiple: (clientIds, enable) => {
        return api.post(`${ENDPOINT}/toggle-multiple`, { clientIds, enable });
    },
    disableMultiple: (clientIds, ex_client_exclude) => {
        return api.post(`${ENDPOINT}/disable-multiple`, { clientIds, ex_client_exclude });
    },
    exportTransactions: (clientId) => {
        return api.post(`${ENDPOINT}/${clientId}/export-point-transactions`, null);
    },
    export: (filters = null) => {
        return api.post(`${ENDPOINT}/export`, { filters });
    },
    exportNewClients: () => {
        return api.post(`${ENDPOINT}/export-new-clients`);
    },
};

export default ClientService;